<!-- 硬件管理详情 -->
<template>
  <div class="hardware-details">
    <hardware-head class="training-head" @onSearchVal="onSearchVal"></hardware-head>
    <div class="hardware-details-content">
      <div class="content-header">
        <img :src="imageUrl" alt="" />
        <span>摄像头</span>
      </div>
      <div class="content-table">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="equipmentName" label="设备名称" width="200">
          </el-table-column>
          <el-table-column prop="equipmentId" label="设备ID" width="200">
          </el-table-column>
          <el-table-column prop="brand" label="品牌" width="200">
          </el-table-column>
          <el-table-column prop="algorithmModel" label="算法模型">
            <template slot-scope="scope">
              <span
                class="algorithmModel-text"
                v-for="(item, index) in scope.row.algorithmModel"
                :key="index"
              >
                <i
                  class="icon-delete"
                  @click="deleteClick(scope.$index, index, '删除算法模型')"
                ></i>
                {{ item }}
              </span>
              <span
                class="el-icon-circle-plus-outline"
                @click="addOutlineClick(scope.$index)"
              ></span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="250">
            <template slot-scope="scope">
              <span
                class="device"
                @click="addDeviceClick(scope.$index, scope.row)"
              >
                <span class="icon-add-device"></span>
                <span>添加设备</span></span
              >
              <span class="line"></span>
              <!-- <span
                class="device"
                @click="deleteDeviceClick(scope.$index, scope.row)"
              > -->
              <span
                class="device"
                @click="
                  deleteClick(scope.$index, scope.row, '确定删除该设备吗？')
                "
              >
                <span class="icon-delete-device"></span>
                <span>删除设备</span>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div class="popup-list">
      <!-- 添加设备 | 编辑设备 -->
      <gat-popup
        :class="[
          'popup-create',
          popupActive === 'create' || popupActive === 'edit' ? 'on' : 'off',
        ]"
        :title="popup.title[popupActive]"
        :primary-button="popup.btnTxt[popupActive]"
        @cancel="cancelPopup"
        @confirm="projectEdite"
      >
        <template v-slot:content>
          <el-form
            class="pop-el-form"
            :model="equipmentForm"
            :rules="rulesEquipment"
            ref="popupUploadForm"
          >
            <el-form-item prop="equipmentName">
              <div class="intxt">
                <span class="label"><i class="required">*</i>设备名称：</span>
                <el-input
                  placeholder="设备名称，必填项"
                  v-model.trim="equipmentForm.equipmentName"
                  maxlength="10"
                  show-word-limit
                />
              </div>
            </el-form-item>
            <el-form-item prop="equipmentId">
              <div class="intxt">
                <span class="label"><i class="required">*</i>设备ID：</span>
                <el-input
                  placeholder="设备ID，必填项"
                  v-model.trim="equipmentForm.equipmentId"
                  show-word-limit
                />
              </div>
            </el-form-item>
            <el-form-item prop="brand">
              <div class="intxt">
                <span class="label"><i class="required">*</i>品牌：</span>
                <el-input
                  placeholder="品牌名称，必填项"
                  v-model.trim="equipmentForm.brand"
                  maxlength="10"
                  show-word-limit
                />
              </div>
            </el-form-item>
            <el-form-item prop="algorithmModelText">
              <div class="intxt">
                <span class="label"><i class="required">*</i>算法模型：</span>
                <el-input
                  placeholder="算法模型名称，必填项"
                  v-model.trim="equipmentForm.algorithmModelText"
                  maxlength="10"
                  show-word-limit
                />
              </div>
            </el-form-item>
          </el-form>
        </template>
      </gat-popup>

      <!-- 删除设备 -->
      <gat-popup
        :class="['popup-delete', popupActive === 'delete' ? 'on' : 'off']"
        :title="''"
        :primary-button="'删除'"
        @cancel="cancelPopup"
        @confirm="deleteProject"
      >
        <template v-slot:content>
          <div class="popup-del-cnt">
            <div class="head">
              <i class="icon-box">
                <icon-base
                  class="icon-info-help"
                  :icon-name="Icons.InfoHelp.iconName"
                  v-bind="Icons.InfoHelp"
                >
                  <icon-info-help class="path-icon-info-help" />
                </icon-base>
              </i>
              <span class="title">{{ deleteTitle }}</span>
            </div>

            <div class="content">删除后将无法恢复</div>
          </div>
        </template>
      </gat-popup>
    </div>

    <el-dialog
      title="添加算法模型"
      :visible.sync="dialogFormVisible"
      width="600px"
      center
    >
      <el-form
        :model="algorithmModelForm"
        :rules="rulesAlgorithmModel"
        ref="algorithmModelForm"
      >
        <el-form-item label="算法模型" prop="name" label-width="80px">
          <el-input
            v-model.trim="algorithmModelForm.name"
            autocomplete="off"
            maxlength="20"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addAlgorithmModel">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="deleteTitle"
      :visible.sync="deleteDialogVisible"
      width="30%"
      center
    >
      <span>删除后将无法恢复</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmDeleteOutline"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      title="添加设备"
      :visible.sync="dialogAddDevice"
      width="600px"
      center
    >
      <el-form
        :model="equipmentForm"
        :rules="rulesEquipment"
        ref="equipmentForm"
        label-width="100px"
        class="dialog-equipmentForm"
      >
        <el-form-item label="设备名称" prop="equipmentName">
          <el-input v-model.trim="equipmentForm.equipmentName"></el-input>
        </el-form-item>
        <el-form-item label="设备ID" prop="equipmentId">
          <el-input v-model.trim="equipmentForm.equipmentId"></el-input>
        </el-form-item>
        <el-form-item label="品牌" prop="brand">
          <el-input v-model.trim="equipmentForm.brand"></el-input>
        </el-form-item>
        <el-form-item label="算法模型" prop="algorithmModelText">
          <el-input v-model.trim="equipmentForm.algorithmModelText"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm('equipmentForm')"
          >添加</el-button
        >
        <el-button @click="resetForm('equipmentForm')">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import HardwareHead from './HardwareHead.vue'

import GatPopup from '@/components/common/GatPopup'

export default {
  name: 'hardware-details',
  components: { HardwareHead, GatPopup },
  data() {
    return {
      imageUrl: require('../../assets/images/hardwareManagement/pic01.png'),
      popupActive: '',
      popup: {
        title: {
          edit: '编辑设备',
          create: '添加设备',
        },
        btnTxt: {
          edit: '确定',
          create: '添加',
        },
      },
      deleteTitle: '确定删除该设备吗？',
      rowIndex: null,
      dialogFormVisible: false,
      deleteDialogVisible: false,
      dialogAddDevice: false,
      algorithmModelForm: {
        name: '',
      },
      rulesAlgorithmModel: {
        name: [{ required: true, message: '请输入算法模型', trigger: 'blur' }],
      },
      tableDataAll: [
        {
          id: 0,
          equipmentName: '摄像头1',
          equipmentId: '11.1.20.101',
          brand: '海康威视',
          // algorithmModel: '垃圾识别 垃圾识别 垃圾识别',
          algorithmModel: ['垃圾识别', '动作识别', '人物识别', '满箱预警'],
        },
        {
          id: 1,
          equipmentName: '摄像头2',
          equipmentId: '12.1.20.101',
          brand: '海康威视',
          algorithmModel: ['垃圾识别', '动作识别', '人物识别'],
        },
        {
          id: 2,
          equipmentName: '摄像头3',
          equipmentId: '13.1.20.101',
          brand: '海康威视',
          algorithmModel: ['垃圾识别', '动作识别', '人物识别'],
        },
      ],
      tableData: [],
      equipmentForm: {
        equipmentName: '',
        equipmentId: '',
        brand: '',
        algorithmModel: '',
      },
      rulesEquipment: {
        equipmentName: [
          { required: true, message: '请输入设备名称', trigger: 'blur' },
        ],
        equipmentId: [
          { required: true, message: '请输入设备ID', trigger: 'blur' },
        ],
        brand: [{ required: true, message: '请输入设备品牌', trigger: 'blur' }],
        algorithmModelText: [
          { required: true, message: '请输入算法模型', trigger: 'blur' },
        ],
      },
      Icons: {
        InfoHelp: {
          iconName: '',
          viewBox: '0 0 36 36',
          width: '36',
          height: '36',
          // iconColor: "#fff"
        },
      },
    }
  },
  created() {
    this.tableData = this.tableDataAll
  },
  methods: {
    // 搜索
    onSearchVal(val) {
      let arrSearch = [],
        tableList = JSON.parse(JSON.stringify(this.tableDataAll))
      arrSearch = tableList.filter((item) => {
        return (
          item.equipmentName.indexOf(val) !== -1 ||
          item.equipmentId.indexOf(val) !== -1
        )
      })
      this.tableData = arrSearch ? arrSearch : this.tableDataAll
    },
    // 添加模型弹窗
    addOutlineClick(index, row) {
      // console.log(index, row)
      this.dialogFormVisible = true
      this.rowIndex = index
      this.algorithmModelForm = {
        name: '',
      }
    },
    // 确认添加模型
    addAlgorithmModel() {
      if (!this.algorithmModelForm.name) {
        return this.$message({
          message: '请输入算法模型',
          type: 'error',
          duration: 2000,
        })
      }
      this.tableData.forEach((item) => {
        if (item.id === this.rowIndex) {
          item.algorithmModel.push(this.algorithmModelForm.name)
        }
      })
      this.dialogFormVisible = false
      this.algorithmModelForm.name = ''
    },
    // 删除弹窗提示 算法模型/设备
    deleteClick(rowIndex, index, deleteTitle) {
      this.rowIndex = rowIndex
      this.deleteTitle = deleteTitle
      if (deleteTitle === '删除算法模型') {
        // this.deleteDialogVisible = true // 提示弹窗
        this.tableData.forEach((item) => {
          if (item.id === rowIndex) {
            item.algorithmModel.splice(index, 1)
          }
        })
      } else {
        this.deleteDialogVisible = true // 提示弹窗
      }
    },
    // 确认删除算法模型
    confirmDeleteOutline() {
      this.tableData.forEach((item, index) => {
        if (item.id === this.rowIndex) {
          this.tableData.splice(this.rowIndex, 1)
          this.tableData.forEach((i, idx) => {
            i.id = idx
          })
        }
      })
      this.deleteDialogVisible = false
    },

    // 添加设备弹窗
    addDeviceClick(index, row) {
      // this.popupActive = 'create'
      this.dialogAddDevice = true
      // console.log(row)
      this.rowIndex = index
    },
    // 确认添加设备
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = JSON.parse(JSON.stringify(this.equipmentForm))
          data.algorithmModel = data.algorithmModelText.split(',')
          this.tableData.splice(this.rowIndex + 1, 0, data)
          this.tableData.forEach((item, index) => {
            item.id = index
          })
          this.resetForm(formName)
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.dialogAddDevice = false
      this.equipmentForm = {
        equipmentName: '',
        equipmentId: '',
        brand: '',
        algorithmModelText: '',
        algorithmModel: [],
      }
    },

    // 添加设备 + 编辑设备
    projectEdite() {
      this.$refs.popupUploadForm.validate((valid) => {
        if (valid) {
          if (this.popupActive === 'create') {
            // 添加
            this.createNewProject()
          } else if (this.popupActive === 'edit') {
            // 编辑
            this.editeProject()
          }
        } else {
          this.$message.error('请将设备相关内容填写完整')
        }
      })
    },
    // 确认添加设备
    createNewProject() {
      let data = JSON.parse(JSON.stringify(this.equipmentForm))
      data.algorithmModel = data.algorithmModelText.split(',')
      // console.log(data.algorithmModel)
      this.tableData.splice(this.rowIndex + 1, 0, data)
      this.tableData.forEach((item, index) => {
        item.id = index
      })
      this.cancelPopup()
    },
    // 编辑弹窗
    activeEditePopup(item) {
      this.equipmentForm.equipmentName = item.equipmentName
      this.equipmentForm.equipmentId = item.equipmentId
      this.equipmentForm.brand = item.brand
      this.equipmentForm.algorithmModel = item.algorithmModel
      this.popupActive = 'edit'
    },
    // 确认编辑设备
    editeProject() {
      this.cancelPopup()
    },
    // 删除设备弹窗
    deleteDeviceClick(idnex, row) {
      this.popupActive = 'delete'
      this.rowIndex = idnex
    },
    // 确认删除设备
    deleteProject() {
      this.tableData.forEach((item, index) => {
        if (item.id === this.rowIndex) {
          this.tableData.splice(this.rowIndex, 1)
          this.cancelPopup()
          this.tableData.forEach((i, idx) => {
            i.id = idx
          })
        }
      })
    },
    // 取消弹窗
    cancelPopup() {
      if (this.popupActive === 'create' || this.popupActive === 'edit') {
        this.equipmentForm = {
          equipmentName: '',
          equipmentId: '',
          brand: '',
          algorithmModelText: '',
          algorithmModel: [],
        }
        this.$refs.popupUploadForm.resetFields()
      }
      this.popupActive = ''
    },
  },
}
</script>

<style lang="scss" scoped>
div {
  box-sizing: border-box;
}

.hardware-details {
  width: 100%;
  // height: 100%;
  background: linear-gradient(90deg, #9688ff, #188aff);
  padding: 0 50px 100px;
  .hardware-details-content {
    .content-header {
      padding: 20px 0;
      img {
        width: 60px;
        height: 60px;
        background: #ffffff;
        border: 2px solid #ffffff;
        border-radius: 30px;
        vertical-align: middle;
        margin: -5px 17px 0 0;
        box-sizing: border-box;
      }
      span {
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #ffffff;
      }
    }
    .content-table {
      ::v-deep .el-table,
      .el-table__expanded-cell {
        background-color: transparent;
      }
      ::v-deep .el-table th,
      ::v-deep .el-table tr {
        background-color: transparent;
        border-bottom: none;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        // background: rgba(255, 255, 255, 0.2);
      }
      ::v-deep .el-table--enable-row-transition .el-table__body td,
      .el-table .cell {
        background-color: transparent;
      }
      ::v-deep.el-table::before {
        //去除底部白线
        left: 0;
        bottom: 0;
        width: 100%;
        height: 0px;
      }

      ::v-deep .el-table {
        overflow: initial;
      }
      ::v-deep .el-table__empty-text {
        color: #fff;
      }

      ::v-deep.el-table__header-wrapper {
        height: 60px;
        border-radius: 5px;
        background: rgba(255, 255, 255, 0.2);
        box-shadow: 0px 0px 10px 0px rgba(1, 14, 47, 0.2);
        margin-bottom: 10px;
        padding: 0 45px;
        box-sizing: border-box;
        tr {
          height: 60px;
        }
      }

      ::v-deep.el-table__header,
      ::v-deep.el-table__body {
        width: auto !important;
      }

      ::v-deep.el-table__body-wrapper {
        height: 600px;
        background: rgba(255, 255, 255, 0.2);
        box-shadow: 0px 0px 10px 0px rgba(1, 14, 47, 0.2);
        border-radius: 5px;
        padding: 0 45px;
        box-sizing: border-box;
        tr {
          height: 100px;
          border-bottom: 1px solid #ccc;
        }
      }

      ::v-deep.el-table td,
      .el-table th.is-leaf {
        border-bottom-color: rgba(255, 255, 255, 0.3);
      }

      ::v-deep.el-button--text {
        margin-left: 10px;
      }
      .el-icon-circle-plus-outline {
        cursor: pointer;
      }
      .device {
        cursor: pointer;
        span {
          float: left;
        }
      }
      .icon-add-device,
      .icon-delete-device {
        width: 16px;
        height: 16px;
        display: inline-block;
        margin: 5px 5px 0 0;
        box-sizing: border-box;
        // &:hover {
        //   color: #4c88ff;
        // }
      }
      .icon-add-device {
        background: url('../../assets/images/hardwareManagement/add-device.png')
          no-repeat;
      }
      .icon-delete-device {
        background: url('../../assets/images/hardwareManagement/delete-device.png')
          no-repeat;
      }
      .line {
        width: 1px;
        height: 14px;
        background: #ffffff;
        float: left;
        opacity: 0.6;
        margin: 5px 20px 0;
      }

      ::v-deep .el-table .cell {
        overflow: initial;
      }

      .algorithmModel-text {
        font-size: 16px;
        border: 1px;
        padding: 0 5px;
        margin-right: 10px;
        box-sizing: border-box;
        display: inline-block;
        &:hover {
          border: 1px solid #ffffff;
          border-radius: 3px;
          .icon-delete {
            width: 13px;
            height: 13px;
            background: url('../../assets/images/hardwareManagement/delete-algorithm.png')
              no-repeat;
            background-size: contain;
            float: right;
            margin-top: -6px;
            margin-right: -11px;
            cursor: pointer;
          }
        }
      }
    }
  }

  .popup-list {
    .popup {
      z-index: 3;
    }
    .popup-create,
    .popup-create-Catalog,
    .popup-score,
    .popup-copy,
    .popup-rename,
    .popup-delete {
      &.off {
        display: none;
      }
    }
    .popup-delete {
      &::v-deep .popup-head {
        border-bottom: 0 none;
      }
      .popup-del-cnt {
        overflow: hidden;
        margin-top: -25px;
        .head {
          .icon-box {
            display: inline-block;
            margin-right: 12px;
            vertical-align: middle;
          }
          .title {
            display: inline-block;
            color: #333;
            vertical-align: middle;
          }
        }
        .content {
          padding: 15px 0;
          text-align: center;
        }
      }
    }
    .popup-create,
    .popup-create-Catalog,
    .popup-copy {
      &::v-deep .popup-inner {
        width: 480px;
        height: 550px;
      }
    }
    .pop-select {
      // margin-top: 20px;
      width: 100%;
      // &::v-deep .el-input__inner {
      //   // &::-webkit-input-placeholder {
      //   //   color: #606266;
      //   // }
      // }
    }
    .pop-textarea {
      // margin-top: 20px;
      &::v-deep .el-textarea__inner {
        font-family: sans-serif;
        resize: none;
      }
    }
    .pop-el-form {
      // margin-top: 20px;
      &::v-deep {
        .el-input__count {
          line-height: 1.5;
        }
        .el-input .el-input__count {
          position: relative;
          top: 20%;
          right: 0.1em;
        }
      }
      .intxt {
        display: flex;
        // flex-direction: row;
        flex-wrap: nowrap;
        // margin: 20px 0;
        font-size: 14px;
        &:first-child {
          margin-top: 20px;
        }
        .label {
          min-width: 6em;
          line-height: 40px;
        }
        .el-input {
          margin-top: 0;
        }
      }
    }
    // /dppe/.el-form-item__error {
    //   padding-left: 100px !important;
    // }

    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      .avatar-uploader-icon {
        color: #8c939d;
        text-align: center;
        width: 130px;
        height: 130px;
        // line-height: 130px;
        text-align: center;
        // background: url('../../assets/images/upload-bg.png') no-repeat -35px -0px;
        background-size: cover;
        border-radius: 4px;
        position: relative;
        overflow: hidden;
        .modify {
          display: flex;
          padding-top: 55px;
          justify-content: center;
          align-content: center;
          box-sizing: border-box;
          .icon {
            width: 17px;
            height: 17px;
            // background: url('../../assets/images/icon_cover-modification.png')
            //   no-repeat;
            background-size: contain;
            margin-right: 10px;
          }
          .modify-text {
            font-size: 16px;
            color: #ffffff;
            line-height: 17px;
          }
        }
      }
      .avatar {
        width: 130px;
        height: 130px;
        display: block;
        border-radius: 4px;
      }
    }
    .avatar-uploader .el-upload:hover {
      border-color: #4c88ff;
    }
  }
}
</style>
